import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import icon1 from "../../assets/images/main/familysites/family1.png";
import icon2 from "../../assets/images/main/familysites/family2.png";
import icon3 from "../../assets/images/main/familysites/family3.png";
import icon4 from "../../assets/images/main/familysites/family4.png";
import icon5 from "../../assets/images/main/familysites/family5.png";
import icon6 from "../../assets/images/main/familysites/family6.png";
import icon7 from "../../assets/images/main/familysites/family7.png";
import icon8 from "../../assets/images/main/familysites/family8.png";
import icon9 from "../../assets/images/main/familysites/family9.png";

// 스타일 컴포넌트
const MainConWrapper = styled.section`
    width: 100%;
    margin: 0 auto;
    padding: 40px 10px;
    background-color: #F2F3F9;
`;

const SectionContainer = styled.section`
    padding: 50px 0;
    max-width: 1000px;
    margin: 10px auto;  
    padding: 0 20px;
`;

const SectionTitle = styled.h2`
    font-size: 24px;
    text-align: left;
    margin-bottom: 30px;
    font-weight: 600;
    color: #333; // 필요에 따라 색상 변경
    position: relative;
    
    &:after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 50px;
        height: 3px;
        background-color: #1a4786; // 필요에 따라 색상 변경
    }
`;

const FamilySitesSection = styled.div`
    margin-bottom: 50px;
    max-width: 1000px;
`;

const QuickLinksGrid = styled.ul`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }
`;

const QuickLinkItem = styled.li`
    text-align: center;
    transition: transform 0.3s ease;
    
    &:hover {
        transform: translateY(-5px);
    }
    
    a, button {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;
        color: #333;
    }
`;

const QuickLinkButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const IconContainer = styled.div`
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    padding: 0;
    margin-bottom: 15px;
    transition: all 0.3s ease;
    
    ${QuickLinkItem}:hover & {
        box-shadow: 0 6px 15px rgba(0, 102, 204, 0.2);
        background-color: #f0f7ff;
    }
`;

const QuickLinkIcon = styled.img`
    width: 40px;
    height: 40px;
    object-fit: contain;
`;

const QuickLinkText = styled.span`
    font-size: 16px;
    font-weight: 500;
    transition: color 0.3s ease;
    
    ${QuickLinkItem}:hover & {
        color: #0066cc;
    }
`;

const FamilySites = () => {
  // 메인 페이지 중앙 섹션에 표시될 Family Sites 항목들
    const quickLinks = [
        { id: 1, title: '제휴안내', path: '/convenience-info/affiliate', icon: icon1 },
        { id: 2, title: '중앙운영위원회 회의록', path: '/student-autonomy/central-committee', icon: icon2 },
        { id: 3, title: '중앙도서관 사물함 사용신청', path: 'https://cafe.naver.com/causamulham', icon: icon3 },
        { id: 4, title: '중앙대학교 홈페이지', url: 'https://www.cau.ac.kr/index.do', icon: icon4 },
        { id: 5, title: '중앙대학교 포탈', url: 'https://mportal.cau.ac.kr/html/temp-104.html', icon: icon5 },
        { id: 6, title: '중앙대학교 서울캠퍼스 학술정보원', url: 'https://library.cau.ac.kr/#/', icon: icon6 },
        { id: 7, title: '중앙대학교 E-Class', path: 'https://eclass3.cau.ac.kr/learningx/main?_=20201130', icon: icon7 },
        { id: 8, title: '중앙대학교 서울캠퍼스 온라인 공간 대여 시스템', path: 'https://causpace.mycafe24.com/', icon: icon8 },
        { id: 9, title: '중앙대학교 레인보우시스템', path: 'http://rainbow.cau.ac.kr/loginw2.jsp?prevurl=', icon: icon9 },
    ];

    // 외부 링크를 여는 함수
    const openExternalLink = (url) => {
        window.open(url, '_blank');
    };

    return (
        <MainConWrapper>
            <SectionContainer>
                {/* Family Sites 섹션 */}
                <FamilySitesSection>
                    <SectionTitle>Family Sites</SectionTitle>
                        <QuickLinksGrid>
                        {quickLinks.map((link) => (
                            <QuickLinkItem key={link.id}>
                            {link.url ? (
                                <QuickLinkButton onClick={() => openExternalLink(link.url)}>
                                <IconContainer>
                                    <QuickLinkIcon src={link.icon} alt={link.title} />
                                </IconContainer>
                                <QuickLinkText>{link.title}</QuickLinkText>
                                </QuickLinkButton>
                            ) : (
                                <Link to={link.path}>
                                <IconContainer>
                                    <QuickLinkIcon src={link.icon} alt={link.title} />
                                </IconContainer>
                                <QuickLinkText>{link.title}</QuickLinkText>
                                </Link>
                            )}
                            </QuickLinkItem>
                        ))}
                        </QuickLinksGrid>
                </FamilySitesSection>
            </SectionContainer>
        </MainConWrapper>
    );
};

export default FamilySites;